import {IReg, REG} from "lib/commons/registry";
import {IUniverseEnv} from "lib/core/universe";
import {BaseElement, MsgLabel, OSkinableInit} from "back/commons/basis";
import {Button, OButtonInit} from "back/commons/widgets/buttons";
import {JSX, ShadowJsx} from "lib/commons/xml/dom";
import {POPUP} from "back/commons/widgets/popups";
import {DOMSH} from "lib/commons/xml/domsh";
import {IO} from "lib/commons/io/io";
import {CDM} from "lib/commons/utils/cdm";
import {JMaintenanceMsg} from "back/core/appFrame";
import {ERROR} from "lib/core/errorReport";

export function openNotifUsers(regs: IReg<IUniverseEnv>[]) {
	POPUP.showDialog(new NotifUsers().initialize({regs: regs}), document.body, {titleBar: {barLabel: {label: "Notification aux utilisateurs connectés"}}, resizer: {}});
}


/**
 * Écran de modifification du profile d'un utilisateur
 */
export interface NotifUsers extends BaseElement {
	initialize(init: ONotifUsersInit): this
}


export interface ONotifUsersInit extends OSkinableInit {
	regs: IReg<IUniverseEnv>[]
}


export class NotifUsers extends BaseElement {

	regs: IReg<IUniverseEnv>[];

	get msgInput() {return this.shadowRoot.getElementById("msg") as HTMLInputElement}

	get timeInput() {return this.shadowRoot.getElementById("time") as HTMLInputElement}

	get sendBtn() {return this.shadowRoot.getElementById("send") as Button}

	get infoArea() {return this.shadowRoot.getElementById("info") as MsgLabel}

	protected async _initialize(init: ONotifUsersInit) {
		this.regs = init.regs;
		const reg = this.regs[0];
		if (!init.reg) init.reg = reg;
		this._attach(this.localName, init,
			<Button î={{reg, label: "Voir les utilisateurs connectés...", uiContext: "dialog"}} onclick={this.onShowUsers}/>,
			<div class="tiArea">Envoyer un message à tous les utilisateurs connectés :</div>,
			<div class="area">
				<div><label class="label" for="time">Heure prévue</label><input id="time" type="time"/></div>
				<div id="msgTypes">
					<label class="label">Message type</label>
					<Button î={{reg, label: "Mise à jour", uiContext: "dialog"}} value="update" onclick={this.onMsgType}/>
					<Button î={{reg, label: "Redémarrage", uiContext: "dialog"}} value="restart" onclick={this.onMsgType}/>
					<Button î={{reg, label: "Arrêt", uiContext: "dialog"}} value="shutdown" onclick={this.onMsgType}/>
				</div>
				<label for="msg">Message à envoyer</label>
				<input id="msg"/>
				<div class="footer">
					<Button id="send" î={{reg, label: "Envoyer", uiContext: "dialog"} as OButtonInit} onclick={this.send}/>
					<MsgLabel id="info" hidden=""/>
				</div>
			</div>,
			<div class="tiArea">Mode maintenance :</div>,
			<div class="area">
				<div style="display:flex">État(s) du mode maintenance<Button î={{reg, icon: "/@skin@/commons/icons/refresh.svg", title: "Rafraîchir l'état du mode maintenance"} as OButtonInit} onclick={this.onMtncState}/></div>
				<ul id="mtncStates">
					{this.regs.map((r: IReg<IUniverseEnv>) => <li><span>{r.env.universe.config.name}</span> : <span id={`mtncSt_${r.env.universe.config.id}`}></span></li>)}
				</ul>
				<div class="footer">
					<Button id="send" î={{reg, label: "Activer la maintenance...", uiContext: "dialog"} as OButtonInit} onclick={this.setMaintenanceOn}/>
					<Button id="send" î={{reg, label: "Désactiver la maintenance", uiContext: "dialog"} as OButtonInit} onclick={this.setMaintenanceOff}/>
				</div>
			</div>
		);
		reg.installSkin("webzone:panel", this.shadowRoot);
		reg.installSkin("form-control-areas", this.shadowRoot);
		this.refreshMtncState();
	}

	async onShowUsers(this: HTMLSelectElement) {
		const me = DOMSH.findHost<NotifUsers>(this);
		const lists = await Promise.all(me.regs.map((reg) => reg.env.universe.config.liaiseUrl.fetchJson<{ account: string, clId: string }[]>(IO.qs("cdaction", "ListClients", "datas", "(community'all')"))));
		const users = new Set<string>();
		lists.forEach((entry: { account: string, clId: string }[]) => {
			entry.forEach((u: { account: string, clId: string }) => {
				users.add(u.account);
			})
		});
		const count = users.size;

		POPUP.showDialog(<p style="margin: .5em">{Array.from(users).join("\n")}</p>, this, {titleBar: {barLabel: {label: `${count} utilisateur(s) connecté(s)`}}});
		//console.log("lists:::::::",lists, users);
	}

	onMtncState() {
		DOMSH.findHost<NotifUsers>(this).refreshMtncState();
	}

	refreshMtncState() {
		this.regs.forEach(async (reg: IReg<IUniverseEnv>) => {
			const resp = await reg.env.universe.config.maintenanceUrl.fetchText();
			const msg = this.shadowRoot.getElementById(`mtncSt_${reg.env.universe.config.id}`);
			if (resp) {
				msg.textContent = "Maintenance en cours";
				msg.title = (JSON.parse(resp) as JMaintenanceResp).msg[0].label;
				msg.className = "mtncOn";
			} else {
				msg.textContent = "-";
				msg.title = "Pas de maintenance en cours";
				msg.className = "mtncOff";
			}
		});
	}

	previousType?: "update" | "shutdown" | "restart" //Compat old Client Xul

	onMsgType(this: Button) {
		const me = DOMSH.findHost<NotifUsers>(this);
		const type = this.getAttribute("value");
		me.previousType = type as any || undefined;
		if (!type) return;
		const tm = me.timeInput.valueAsNumber;
		let time: string;
		if (tm >= 0) {
			const dt = new Date();
			dt.setHours(0, 0, 0, 0);
			dt.setTime(dt.getTime() + tm);
			time = new Intl.DateTimeFormat("fr", {timeStyle: "short"} as any/*TS3.7 timeStyle indéfini*/).format(dt);
		}
		switch (type) {
		case "update":
			me.msgInput.value = time ? `Attention, une mise à jour du serveur est prévue vers ${time}` : "Attention, une mise à jour du serveur est imminente";
			break;
		case "shutdown":
			me.msgInput.value = time ? `Attention, un arrêt du serveur est prévu vers ${time}` : "Attention, l'arrêt du serveur est imminent";
			break;
		case "restart":
			me.msgInput.value = time ? `Attention, un redémarrage du serveur est prévu vers ${time}` : "Attention, le redémarrage du serveur est imminent";
			break;
		}
	}

	send(this: Button) {
		const me = DOMSH.findHost<NotifUsers>(this);
		const msg = me.msgInput.value;
		if (!msg) {
			me.infoArea.setCustomMsg("Saisissez un message", "error");
			return;
		}
		me.sendBtn.disabled = true;
		setTimeout(() => {
			me.sendBtn.disabled = false;
			me.infoArea.setCustomMsg(null);
		}, 5000);
		const tm = me.timeInput.valueAsNumber;
		let until: number;
		if (tm >= 0) {
			const now = Date.now();
			const dt = new Date(now);
			dt.setHours(0, 0, 0, 0);
			dt.setTime(dt.getTime() + tm);
			until = now > dt.getTime() ? dt.getTime() + 86400000 : dt.getTime();
		}
		try {
			for (let reg of me.regs) {
				const m: JMaintenanceMsg = {
					svc: "liaise",
					type: "maintenance",
					opType: me.previousType, //compat ancien client Xul
					msg,
					until: until
				};
				reg.env.universe.config.liaiseUrl.fetchVoid(IO.qs("cdaction", "DispatchMsg", "datas", CDM.stringify(m)), {method: "POST"});
			}
			me.infoArea.setCustomMsg("Le message a été envoyé", "info");
		} catch (e) {
			me.infoArea.setCustomMsg("Envoi du message en échec", "error");
			console.log(e);
		}
	}

	setMaintenanceOn(this: Button) {
		const me = DOMSH.findHost<NotifUsers>(this);
		const popup = POPUP.showDialog(<div style="margin:.5em"><ShadowJsx skin="webzone:panel">
			<div>Message de maintenance aux utilisateurs :</div>
			<input id="txt" style="width:40em; font-size:inherit;" value="Le serveur est actuellement en maintenance, remise en service prévue vers XXXX."/>
			<Button î={{reg: me.regs[0], label: "Entrer en maintenance", uiContext: "dialog"} as OButtonInit} onclick={async function (this: Button) {
				this.disabled = true;
				try {
					const input = DOMSH.findHost(this).shadowRoot.getElementById("txt") as HTMLInputElement;
					if (!input.value) POPUP.showNotifError("Saisissez un message de maintenance", this);
					else {
						await me.setMaintenance(input.value);
						popup.close();
					}
				} catch (e) {
					this.disabled = false;
					ERROR.report("Set maintenance mode failed", e);
				}
			}}/>
		</ShadowJsx></div>, me, {titleBar: {barLabel: {label: "Mode maintenance"}}})
	}

	setMaintenanceOff(this: Button) {
		DOMSH.findHost<NotifUsers>(this).setMaintenance();
	}

	async setMaintenance(txt?: string) {
		await Promise.all(this.regs.map((reg: IReg<IUniverseEnv>) => {
			return reg.env.universe.config.maintenanceUrl.fetchVoid(IO.qs("cdaction", "SetMaintenanceMode", "param", txt), {method: "POST"});
		}));
		this.refreshMtncState();
	}
}


REG.reg.registerSkin('c-notif-users', 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-width: 40em;
	}

	.tiArea {
		margin: .5em;
	}

	.area {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding: .5em;
		border: 1px solid var(--border-color);
		margin: .5em;
	}

	#msgTypes {
		display: flex;
	}

	#time {
		margin: .5em;
	}


	#msg {
		padding: .5em;
		font-weight: bold;
	}

	.footer {
		display: flex;
		justify-content: center;
	}

	.label {
		display: inline-block;
		min-width: 9em;
		margin: .5em 0;
	}

	.mtncOff {
		color: var(--fade-color);
	}

	.mtncOn {
		color: var(--warning-color);
	}
`);

customElements.define('c-notif-users', NotifUsers);

interface JMaintenanceResp {
	msg: { lang: string, label: string }[]
}